import * as React from "react";
import Grid from "@mui/material/Grid";
import TopBar from "../../components/TopBar/TopBar";
import { LayoutPage } from "../../components/Layout/layoutPage";
import { Button, CircularProgress, Typography } from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import HomeIcon from "@mui/icons-material/Home";
import SendIcon from "@mui/icons-material/Send";
import TabsCustom from "../../components/Tabs/Tabs";
import { useEffect, useRef, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import iconPDF from "../../assets/img/iconPDF.png";
import { makeStyles } from "@mui/styles";
import Loading from "../../components/Loading/loading";
import axios from "axios";
import useSWR from "swr";
import ErrorCustom from "../../components/Error/Error";
import { GridPDF } from "../../components/GrdiPreventivi/GridPDF";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { importBaseActions } from "../../store/reducers/base";
import { current } from "@reduxjs/toolkit";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import DownloadIcon from "@mui/icons-material/Download";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import translate from "../../i18n/messages/translate";
import { getProductName } from "../../Utility";
import { AmountItem, NumberItem } from "./richiesta";
import { useConfigurationsService } from "../../v2/services/configurations_service";
import { getCurrentUser } from "../../v2/core/common_functions";
import { Allegati } from "../../v2/models/allegati";
import { useDoorConfigurationsApi } from "../../v2/api/door_configurations_api";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';

const GeneraPDF = () => {
  const count = useSelector(state => state.base);
  const currentUser = getCurrentUser(count);
  const configurationService = useConfigurationsService();
  const baseActions = importBaseActions();
  const dispatch = useDispatch();
  const doorConfigurationsApi = useDoorConfigurationsApi();
  const [state, setState] = useState({
    status: "loading",
    pdfData: null,
    error: null
  });
  const [selectedFiles, setSelectedFiles] = useState([]);
  //const history = useHistory();
  const navigate = useNavigate();
  const classes = useStyles();
  const location = useLocation();

  let axiosConfig = {
    headers: {
      Authorization: "Bearer " + count.user.token,
    },
  };
  // const fetcher = (url) =>
  //   axios.post(url, { id: count.idPorta }, axiosConfig).then((res) => res.data.data);
  // const { data, error } = useSWR([`${process.env.REACT_APP_API_URL}/categories-steps`], fetcher);

  // const fetcher1 = (url) =>
  //   axios
  //     .post(url, { id: count.quoteId, user: count.user.id }, axiosConfig)
  //     .then((res) => res.data);
  // const { data: pdf, error: errorPdf } = useSWR([`${process.env.REACT_APP_API_URL}/pdf`], fetcher1);

  const [value, setValue] = useState();
  const [isBusy, setIsBusy] = useState(false);
  const [isShowMenuExtra, setIsShowMenuExtra] = useState(false);
  const handleChange = () => {
    state.steps &&
    state.steps.map((el) =>
        `/${el.slug}` === location.pathname ? setValue(el.id) : null
      );
  };
  const dwAllegati= async (allegatoId,fileName)=> {
    doorConfigurationsApi.downloadAllegato(count.user,allegatoId,count.quoteId,fileName)
  }
  const load = async () => {
    try {
      const [res, files] = await Promise.all([
        axios.get(`${process.env.REACT_APP_API_URL}/pdf?quoteId=${count.quoteId}`, axiosConfig),
        doorConfigurationsApi.getAllegati(currentUser, count.quoteId)
      ]);
      setSelectedFiles(files);
      if (res.data.data.quote.end_client_summary) {
        try {
          res.data.data.quote.end_client_summary = JSON.parse(res.data.data.quote.end_client_summary);
        } catch (e) {

        }
      }

      setState({
        ...state,        
        pdfData: res.data.data,
        status: "idle"
      });
    } catch (e) { 
      setState({
        ...state,
        status: "error",
        error: e
      });
    }
  }

  const inviaOrdine = async () => {
    setIsBusy(true);
    try {
      let res = await axios.get(`${process.env.REACT_APP_API_URL}/send-order?quoteId=${state.pdfData.quote.id}`, axiosConfig);

      if (res.data.success == 0) throw res.data.message;

      alert("L'ordine è stato inviato con successo");

      navigate("/configurations");
    } catch (e) {
      alert("Si è verificato un errore durante l'invio dell'ordine. Ti preghiamo di riprovare.");

      setIsBusy(false);
    }
  }

  const isOrderSent = () => {
      return "order_sent" == state.pdfData?.quote?.status || 
      "order_confirmed" == state.pdfData?.quote?.status;
  }

  const resetPreventivo = async () => {
      setIsBusy(true);
      try {
          if (!state.pdfData?.quote?.id) throw "invalid configuration";

          await configurationService.resetQuote(currentUser, Number(state.pdfData?.quote?.id));

          navigate(`/dimensioni`);
      } catch (e) {
          setIsBusy(false);

          let message = "";
          if (typeof e == "string") {
              message = e;
          } else {
              if (e.severity == "error") {
                  message = e.message;
              } else if (e.severity == "warning") {
                  message = e.message;
              }
          }
          alert(message);
      }
  }

  useEffect(() => {
    load();
    //return handleChange();
  }, []);

  if ("error" == state.status) return <ErrorCustom route={"/configurations"} />;
  if ("loading" == state.status) return <Loading />;

  return (
    <LayoutPage>
      <div style={{ flex: "0 0 auto" }}>
        <TopBar />

        <div className={"d-flex justify-content-between p-3"}>
            <div className="d-flex flex-column" style={{ lineHeight: "1" }}>
              <h4 className="h4 fw-bold">
                Il tuo preventivo è pronto!<br />
                <small style={{fontWeight: "normal", fontSize: "1rem"}}>Puoi scaricare e stampare una copia del preventivo appena generato</small>
              </h4>
            </div>
            <div className="d-flex align-items-start" style={{gap: ".5rem"}}>
              <Button variant="contained" color="secondary" onClick={() => navigate("/configurations")}>
                  <CloseIcon />
                  <span className="ms-2">CHIUDI</span>
              </Button>              
            </div>
        </div>
      </div>

      <div style={{ flex: "1 1 auto", minHeight: "0", overflowY: "auto" }}>
        <div className="row m-0">
          <div className="col-xl-6 p-0">
            <div className="p-4">
              <img src={`${process.env.REACT_APP_WEB_URL}/pdf/imgPreview?quoteId=${state.pdfData.quote.id}`} className="w-100" />
              
              <div className="mt-3">
                <h6 className="h6 fw-bold" style={{borderBottom: "solid 1px var(--bs-primary)"}}>DIMENSIONI DEL VANO</h6>
                <table className="w-100">
                  <tbody>
                    <tr>
                      <td className="border-bottom">Architrave:</td>
                      <th className="text-end border-bottom">{state.pdfData.quote.architrave} mm</th>                    
                    </tr>
                    <tr>
                      <td className="border-bottom">Altezza:</td>
                      <th className="text-end border-bottom">{state.pdfData.quote.height} mm</th>                    
                    </tr>
                    <tr>
                      <td className="border-bottom">Larghezza:</td>
                      <th className="text-end border-bottom">{state.pdfData.quote.width} mm</th>
                    </tr>
                    <tr>
                      <td className="border-bottom">Spalletta sinistra:</td>
                      <th className="text-end border-bottom">{state.pdfData.quote.distance_ss} mm</th>
                    </tr>
                    <tr>
                      <td>Spalletta destra:</td>
                      <th className="text-end">{state.pdfData.quote.distance_ds} mm</th>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="mt-3">
                <h6 className="h6 fw-bold" style={{borderBottom: "solid 1px var(--bs-primary)"}}>MISURE PORTA</h6>
                <table className="w-100">
                  <tbody>
                    <tr>
                      <td className="border-bottom">Quantità:</td>
                      <th className="text-end border-bottom">{state.pdfData.quote.qty ? state.pdfData.quote.qty.toFixed(2) : 0}</th>                    
                    </tr>
                    <tr>
                      <td className="border-bottom">Altezza:</td>
                      <th className="text-end border-bottom">{state.pdfData.quote.height_calculate} mm</th>                    
                    </tr>
                    <tr>
                      <td className="">Larghezza:</td>
                      <th className="text-end">{state.pdfData.quote.width_calculate} mm</th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="col-xl-6 p-0">
            <div className="p-4">
              <h6 className="h6 fw-bold" style={{borderBottom: "solid 1px var(--bs-primary)"}}>PRODOTTO</h6>
              <table>
                <thead>
                  <tr>
                    <th className="border-bottom" style={{width: "80%"}}>DESCRIZIONE</th>
                    <th className="border-bottom text-end" style={{width: "20%"}}>Q.TÀ</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border-bottom">{state.pdfData.quote.description}</td>
                    <td className="border-bottom text-end">{state.pdfData.quote.qty}</td>
                  </tr>
                </tbody>
              </table>
              
              <h6 className="h6 fw-bold mt-3" style={{borderBottom: "solid 1px var(--bs-primary)"}}>ACCESSORI</h6>
              <table style={{width: "100%"}}>
                <thead>
                  <tr>
                    <th className="border-bottom" style={{width: "10%"}}>CODICE</th>
                    <th className="border-bottom" style={{width: "70%"}}>DESCRIZIONE</th>
                    <th className="border-bottom text-end" style={{width: "20%"}}>Q.TÀ</th>
                  </tr>
                </thead>
                <tbody>
                  {state.pdfData.accessories.map(a => (
                    <tr key={a.id}>
                      <td className="border-bottom align-top">{a.codice}</td>
                      <td className="border-bottom">{a.descrizione}</td>
                      <td className="border-bottom text-end">{a.qty ? a.qty.toFixed(2) : 0} {a.um}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {state.pdfData.quote && (
                <div className="mt-1 rounded-3 p-3 mt-3 bg-light " style={{ position: "relative" }}>
                  <h4 className="h4 fw-bold">Totale:</h4>
                  <div className="d-flex justify-content-between">
                    <NumberItem label="Quantità:" value={state.pdfData.quote.qty} />
                  </div>

                  <div className="d-flex justify-content-between">
                    <AmountItem label="Totale merce:" value={state.pdfData.quote.base_net_price} />
                  </div>

                  <div className="d-flex justify-content-between">
                    <AmountItem label="Totale servizi:" value={state.pdfData.quote.total_services} />
                  </div>

                  {!count.user.isCustomer && (
                    <>
                      <div className="my-1 text-center" style={{lineHeight: "1"}}>
                        <hr />
                        {process.env.NODE_ENV != "production" && <small>Rivendita</small>}
                      </div>

                      <div className="d-flex justify-content-between">
                        <AmountItem label="Sconto:" value={state.pdfData.quote.total_discount} />
                      </div>

                      <div className="d-flex justify-content-between">
                        <AmountItem label="Totale merce netto:" value={state.pdfData.quote.net} />

                      </div>

                      <div className="d-flex justify-content-between">
                        <AmountItem label="Totale imponibile:" value={state.pdfData.quote.taxable_amount} />
                      </div>

                      <div className="d-flex justify-content-between">
                        <AmountItem label="Totale iva:" value={state.pdfData.quote.total_taxes} />
                      </div>

                      <div className="d-flex justify-content-between">
                        <AmountItem label="Totale ordine:" value={state.pdfData.quote.total} />
                      </div>
                    </>
                  )}

                  {count.user.isCustomer && state.pdfData.quote.end_client_summary && (
                    <>                      
                      <div className="my-1 text-center" style={{lineHeight: "1"}}>
                        <hr />
                        {process.env.NODE_ENV != "production" && <small>Cliente finale</small>}
                      </div>

                      <div className="d-flex justify-content-between">
                        <AmountItem label="Sconto:" value={state.pdfData.quote.end_client_summary.totalDiscount} />
                      </div>

                      <div className="d-flex justify-content-between">
                        <AmountItem label="Totale merce netto:" value={state.pdfData.quote.end_client_summary.net} />
                      </div>

                      <div className="d-flex justify-content-between">
                        <AmountItem label="Totale imponibile:" value={state.pdfData.quote.end_client_summary.taxableAmount} />
                      </div>

                      <div className="d-flex justify-content-between">
                        <AmountItem label="Totale iva:" value={state.pdfData.quote.end_client_summary.totalTaxes} />
                      </div>

                      <div className="d-flex justify-content-between">
                        <AmountItem label="Totale ordine:" value={state.pdfData.quote.end_client_summary.total} />
                      </div>
                    </>
                  )}
                {selectedFiles.length > 0 && (<>
                  <div className="mt-2">
                    <h4 className="h4 fw-bold">Allegati:</h4>
                    {selectedFiles.map((file, index) => (
                      <div
                        key={file.guid}
                        className="flex items-center justify-between p-2 border rounded-md mb-1"
                      >
                        <span>{file.filename}</span>
                        <CloudDownloadIcon
                          className="text-red-500 cursor-pointer hover:text-red-700"
                          onClick={() => dwAllegati(file.guid,file.filename)}
                        />
                      </div>
                    ))}
                  </div></>
                )}
                </div>
              )}
              <div className="d-flex flex-row-reverse px-4 py-2">
                  {!isOrderSent() && <Button variant="contained" color="primary" size="small" className="ms-2" onClick={() => inviaOrdine()}>
                      <SendIcon className="me-2" style={{ fontSize: "1.25rem" }} />
                      INVIA ORDINE
                  </Button>}

                  {currentUser.isCustomer && (
                      <Button variant="contained" color="primary" size="small" className="ms-2" onClick={(e) => {
                        window.open(`${process.env.REACT_APP_WEB_URL}/pdf/customer?quoteId=${state.pdfData?.quote?.id}`);
                      }}>
                          <DownloadIcon className="me-2" style={{ fontSize: "1.25rem" }} />
                          SCARICA COPIA CLIENTE
                      </Button>
                  )}

                  <Button variant="contained" color="primary" size="small" className="ms-2" onClick={(e) => {
                    window.open(`${process.env.REACT_APP_WEB_URL}/pdf/retail?quoteId=${state.pdfData?.quote?.id}`);
                  }}>
                      <DownloadIcon className="me-2" style={{ fontSize: "1.25rem" }} />
                      SCARICA PREVENTVO
                  </Button>

                  {"not_started" == state.pdfData?.quote?.sync_status && <Button variant="contained" color="secondary" size="small" onClick={() => resetPreventivo()}>
                      <RestartAltIcon className="me-2" style={{ fontSize: "1.25rem" }} />
                      RESET
                  </Button>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </LayoutPage>
  );
};

const useStyles = makeStyles({
  root: {
    "& MuiTabs-flexContainer css-heg063-MuiTabs-flexContainer": {
      justifyContent: "center",
    },
  },
});

export default GeneraPDF;
